import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import BracketBoard from '../brackets/BracketBoard';

// Full class strings are spelled out literally (not interpolated) so
// Tailwind's static scanner can actually find and generate them.
const DIRECTION_META = {
  E: { label: 'Main Draw', gridClass: 'xl:col-start-2 xl:row-start-2', primary: true },
  W: { label: 'West', gridClass: 'xl:col-start-1 xl:row-start-2' },
  N: { label: 'North', gridClass: 'xl:col-start-2 xl:row-start-1' },
  S: { label: 'South', gridClass: 'xl:col-start-2 xl:row-start-3' },
  NE: { label: 'Northeast', gridClass: 'xl:col-start-3 xl:row-start-1' },
  NW: { label: 'Northwest', gridClass: 'xl:col-start-1 xl:row-start-1' },
  SE: { label: 'Southeast', gridClass: 'xl:col-start-3 xl:row-start-3' },
  SW: { label: 'Southwest', gridClass: 'xl:col-start-1 xl:row-start-3' },
};

// Reading order for the mobile stack (xl:grid-cols-3 is what turns this into
// the actual 3x3 compass layout — below that breakpoint col/row-start utilities
// are no-ops on a single-column grid, so items just stack in this order).
const STACK_ORDER = ['E', 'W', 'N', 'S', 'NE', 'NW', 'SE', 'SW'];

const CompassGrid = ({ groups, activeDirections }) => {
  const { theme } = useTheme();
  const ordered = STACK_ORDER.filter((d) => activeDirections.includes(d));

  return (
    <div>
      <p className={`mb-4 text-sm ${theme.textSecondary}`}>
        {activeDirections.length} of 8 directions in play — losers drop into a consolation bracket instead of
        going home. Bracket shape is fully derived from participant count, nothing to configure.
      </p>
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
        {ordered.map((dir) => {
          const meta = DIRECTION_META[dir];
          const bracket = groups[dir];
          return (
            <div
              key={dir}
              // `border-current` + `theme.text` — same technique as
              // MatchCard/RegionCard/CenterMatch — so this direction panel's
              // border reliably contrasts against its own fill in every
              // theme, not just the ones where `theme.border` happens to
              // read differently from `theme.card`/`theme.tabActive`.
              className={`${meta.gridClass} rounded-xl border border-current p-4 ${theme.text} ${
                meta.primary ? `${theme.tabActive} ${theme.shadow}` : theme.card
              }`}
            >
              <div className={`mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-wide ${meta.primary ? '' : theme.textMuted}`}>
                <span className={`flex h-5 w-5 items-center justify-center rounded ${meta.primary ? theme.buttonPrimary : theme.backgroundSecondary} text-[10px]`}>
                  {dir}
                </span>
                {meta.label}
              </div>
              <BracketBoard rounds={bracket.rounds} compact={!meta.primary} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CompassGrid;
